/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Term_ColumnInputs */



/**
* | output |
* | --- |
* | "Term" |
*
* @param {Knp_Lookup_Term_ColumnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_term_column = /** @type {((inputs?: Knp_Lookup_Term_ColumnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Term_ColumnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Begriff")
	if (locale === "it") return /** @type {LocalizedString} */ ("Termine")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Срок")
	if (locale === "es") return /** @type {LocalizedString} */ ("Término")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("学期")
	if (locale === "ja") return /** @type {LocalizedString} */ ("学期")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अवधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Prazo")
	return /** @type {LocalizedString} */ ("Term")
});